import { WorkersContainer } from './WorkersContainer';

const name = 'JobsiteWorkersContainer';

export { name, WorkersContainer };
